import HorizontalAlignment from 'hb-builder/components/common/SettingsLibrary/CommonSettings/HorizontalAlignment';
import Padding from 'hb-builder/components/common/SettingsLibrary/CommonSettings/Padding';
import SectionHeight from 'hb-builder/components/common/SettingsLibrary/CommonSettings/SectionHeight';
import VerticalAlignment from 'hb-builder/components/common/SettingsLibrary/CommonSettings/VerticalAlignment';
import type { ComponentSettingsTab } from 'hb-builder/types/settings';
import { isPaddingTooBig } from 'hb-builder/utils/attributes';

const GlobalSettings = ({
  item,
  onChange,
  permissions: { can: { alertOnCustomPadding } } = {
    can: {},
    flags: {},
  },
}: ComponentSettingsTab) => {
  if (!item.children || !item.children[0].children) {
    return null;
  }

  if (!item.children || !item.children[0].children) {
    return null;
  }

  const column = item.children[0];
  const [headline, subline, button] = column.children || [];

  const handleChange = ({ values }) => {
    onChange({
      ids: [headline.id, subline.id, button.id],
      values,
    });
  };

  const settingProps = { item, onChange };

  return (
    <>
      <Padding
        alert={{
          enabled: alertOnCustomPadding,
          fillConditions: (padding) => isPaddingTooBig(padding, 30),
          message: s__(
            'Builder|Please check if this value displays well on mobile',
          ),
        }}
        settingKey="containerPadding"
        title={__('Padding (in pixels)')}
        {...settingProps}
      />
      <HorizontalAlignment
        item={headline}
        onChange={handleChange}
        title={__('Horizontal alignment')}
      />
      <VerticalAlignment item={item} onChange={onChange} />
      <SectionHeight item={item} onChange={onChange} />
    </>
  );
};

export default GlobalSettings;
